export default __webpack_public_path__ + "static/login-bg-2d608fa661bacae2b68a269444755d87.jpg";